/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface HospitalizationGetMedicalFormPdf$Pdf$Params {

/**
 * filter criteria
 */
  languageCode?: string;

/**
 * filter criteria
 */
  hospitalizationId?: number;

/**
 * filter criteria
 */
  medFormName?: string;
}

export function hospitalizationGetMedicalFormPdf$Pdf(http: HttpClient, rootUrl: string, params?: HospitalizationGetMedicalFormPdf$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
  const rb = new RequestBuilder(rootUrl, hospitalizationGetMedicalFormPdf$Pdf.PATH, 'get');
  if (params) {
    rb.query('languageCode', params.languageCode, {});
    rb.query('hospitalizationId', params.hospitalizationId, {});
    rb.query('medFormName', params.medFormName, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<File>;
    })
  );
}

hospitalizationGetMedicalFormPdf$Pdf.PATH = '/v1/Hospitalization/GetMedicalFormPDF';
